var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapNodeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-68.3%",
    y: "-68.3%",
    width: "236.7%",
    height: "236.7%",
    filterUnits: "objectBoundingBox",
    id: "z0nxo8hm5a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0.5 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#z0nxo8hm5a)",
    transform: "rotate(90 15.002 31)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.417 13.587 16.413.586A1.987 1.987 0 0 0 15.002 0c-.533 0-1.036.206-1.412.586L.586 13.587A1.987 1.987 0 0 0 0 14.998c0 .533.206 1.036.586 1.412L13.59 29.414c.376.376.879.586 1.412.586.532 0 1.035-.206 1.41-.586L29.418 16.41c.377-.376.586-.879.586-1.412 0-.532-.206-1.035-.586-1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.475 15.471 15.471 28.475a.686.686 0 0 1-.942 0L1.528 15.471a.667.667 0 0 1 0-.942L14.529 1.528a.66.66 0 0 1 .939 0l13.004 13.004c.26.26.26.683 0 .942l.003-.003z"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 21
  }, "Y")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapNodeSelected);
export default __webpack_public_path__ + "static/media/map-node-selected.aa499e7a2282c8b707c5f7e64a8881c1.svg";
export { ForwardRef as ReactComponent };